export const LOGO_URL = "https://customer-assets-cm19k8pv.emergentagent.net/job_meet-connect-capture/artifacts/0n1i4uby_7FBEA3C2-CC69-40C0-869A-F28DF2B0403D.webp";

export const IMG_HERO = "https://images.unsplash.com/photo-1768677455646-41bc9ce7e342?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_ROMANTIC = "https://images.unsplash.com/photo-1707254646120-ab5ac364a4d5?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_FRIENDSHIP = "https://images.unsplash.com/photo-1600073798112-ae8468f9a72c?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_CREATIVE = "https://images.unsplash.com/photo-1765429159499-d3be4949d843?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_PHOTOGRAPHER_LANDING = "https://images.unsplash.com/photo-1765429161056-9bc71ca087d3?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_ABOUT = "https://images.unsplash.com/photo-1624953505153-163c862bd51d?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_SAFETY = "https://images.unsplash.com/photo-1651018584640-70e23929f0a5?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_MATCH_BG = "https://images.unsplash.com/photo-1624953504986-718e85faf05c?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_AUTH_BG = "https://images.unsplash.com/photo-1777892548531-3fc07b2491d2?crop=entropy&cs=srgb&fm=jpg&q=85";
export const IMG_CONTACT = "https://images.unsplash.com/photo-1756916474773-ea9cd77edaa2?crop=entropy&cs=srgb&fm=jpg&q=85";

export const TESTIMONIALS = [
  {
    quote: "I was nervous at first, but it ended up being one of the most fun and authentic experiences I've ever had. The photos? Absolutely incredible.",
    name: "Jessica M.",
    role: "Stranger",
    avatar: "https://images.unsplash.com/photo-1690681953431-a37d95b71d5b?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    quote: "We laughed the whole time and walked away with photos we'll treasure forever. It felt like meeting an old friend.",
    name: "Tyler R.",
    role: "Stranger",
    avatar: "https://images.unsplash.com/photo-1762708548366-a4aeac157758?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
  {
    quote: "As a photographer, this platform makes it easy to create meaningful experiences and build a portfolio with purpose.",
    name: "Jane D.",
    role: "Photographer",
    avatar: "https://images.unsplash.com/photo-1760552069633-c05f246a5d8c?crop=entropy&cs=srgb&fm=jpg&q=85",
  },
];
